export const BACKGROUND_COLOR = '#F3F7F6';
export const SELECTION_FRAME_COLOR = '#4666E5';
export const IDEA_URL_COLOR = '#4666E5';
export const IDEA_FILL_COLORS = ['#FFF', '#FFF', BACKGROUND_COLOR];
export const CONNECTION_COLOR = '#CCCCCC';
export const IDEA_SPACING = [15, 10, 5];
export const IDEA_LINES = [false, false, true];
export const IDEA_IMAGE_SIZES = [100, 50];
export const TREE_PARENT_GAP = 50;
export const TREE_SIBLING_GAP = 10;
export const IDEA_LABEL_DEFAULT = 'Idea';
export const IDEA_LABEL_PLACEHOLDER = 'Enter idea…';
export const IDEA_USER_COLORS = ['#4666E5', '#F9A03F', '#09BC8A', null];
